<button
  type="button"
  mat-button
  class="lum-button"
  [disabled]="isInvoiceStatusCompleteSalesOrderStatusShipped"
  (click)="togglePackageMenu($event)"
  [matMenuTriggerFor]="menu"
>
  <lum-ui-icon width="10" height="10" class="mr-2" icon="add-circle"></lum-ui-icon>
  Invoice Templates
</button>
<mat-menu #menu="matMenu">
  <button
    *ngFor="let package of packages; trackBy: trackById"
    (click)="onSelectPackage(package)"
    mat-menu-item
  >
    {{ package.name }}
  </button>
  <mat-divider></mat-divider>
  <button (click)="onManagePackage()" mat-menu-item
    >Manage Invoice Templates</button
  >
</mat-menu>
